import script from "./StreamManagerLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./StreamManagerLayout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__